import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, shareReplay, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  constructor(private http: HttpClient) { }

  private currentUserSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public currentUser$: Observable<any> = this.currentUserSubject.asObservable();

  loadCurrentUser(): Observable<any> {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
    if (!token) {
      return new Observable(observer => {
        observer.complete();
      });
    }

    return this.http
      .get<any>(`${environment.baseUrl}users/get-current-tenant`)
      .pipe(
        tap(user => {
          this.currentUserSubject.next(user);
        }),
        shareReplay(1),
        catchError(err => {
          console.error('loadCurrentUser error', err);
          throw err;
        })
      );
  }

  get currentUser() {
    return this.currentUserSubject.value;
  }

  verifyDomain(domain: string) {
    if (environment.impersonateEnabled === true) {
      domain = environment.impersonateDomain;
    }
    return this.http.get<{ exists: boolean }>(`${environment.baseUrl}properties/verify-domain?domain=${domain}`);
  }

  getPropertyByDomain(domain: string) {
    if (environment.impersonateEnabled === true) {
      domain = environment.impersonateDomain;
    }
    return this.http.get<any>(`${environment.baseUrl}properties/get-by-domain?domain=${domain}`);
  }
}
